import { Component, Input } from '@angular/core';

import { SearchResultItemComponent } from './search-result-item/search-result-item.component';
import { SearchResult } from '../../../graphql/generated/generated-types';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-shop-items',
  standalone: true,
  imports: [SearchResultItemComponent],
  templateUrl: './shop-items.component.html',
  styleUrl: './shop-items.component.scss'
})
export class ShopItemsComponent {
  @Input() showSaveAction!: boolean;
  @Input() searchResults!: SearchResult[];
}
